import {
    API_ERRORS,
    axiosConfigs,
    finalizeResponse,
    handleError
} from 'tradera/utils/api';
import { touchWebClient, webApiClient } from 'tradera/utils/http';

function getSystemMessages() {
    return webApiClient
        .get('/member/system-messages')
        .then(finalizeResponse())
        .catch(
            handleError({
                // Ignore 400 & 401 errors that slip through token refresh
                400: API_ERRORS.IGNORE_ME,
                401: API_ERRORS.IGNORE_ME
            })
        );
}

function getMessagingNotifications() {
    return touchWebClient.get('/api/messaging/stats', {
        cancelTokenId: 'fetchMessagingNotifications',
        ...axiosConfigs.authenticated
    });
}

export { getSystemMessages, getMessagingNotifications };
